module.exports = __webpack_public_path__ + "static/media/sardines-miso-lid.810fa77d.png";